import React from 'react';
import {motion} from 'framer-motion';

import styles from './styles/feature-card.module.css';

const cardMotion = {
  hidden: { opacity: 0, y: 50 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};

const imgMotion = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { 
    opacity: 1, 
    scale: 1,
    transition: {
      duration: 0.5
    }
  }
};

export default function FeatureCard({ type, title, subTitle, Image, LeftImage, RightImage, LastImage, SecondImage, ThirdImage, FourImage, FiveImage, isVisible, showSideImages, showLastImage }) {
  const errorImgMap = [
    { id: 1, Component: Image },
    { id: 2, Component: SecondImage },
    { id: 3, Component: ThirdImage },
    { id: 4, Component: FourImage },
    { id: 5, Component: FiveImage }
  ];

  return (
    <motion.div
      className={styles.wrapper} 
      data-type={type}
      initial='hidden'
      animate={isVisible ? 'visible' : 'hidden'}
      variants={cardMotion}
    >
      <div className={styles.boxTitle} data-type={type} >
        {title}
        {subTitle}
      </div>
      {type === 'first' &&
        <motion.div 
          className={styles.boxImage}
          data-type={type}
          variants={imgMotion}
        >
          <motion.div
            className={styles.leftImage}
            initial={{ opacity: 0, x: -50 }}
            animate={showSideImages ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
          >
            <LeftImage />
          </motion.div>
          <div className={styles.mainImage}>
            <Image />
          </div>
          <motion.div 
            className={styles.rightImage}
            initial={{ opacity: 0, x: 50 }}
            animate={showSideImages ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <RightImage />
          </motion.div>
        </motion.div>
      }

      {type === 'second' &&
        <div className={styles.boxImage} data-type={type}>
          <motion.div
            initial={{ opacity: 1 }}
            animate={{ opacity: showLastImage ? 0 : 1 }}
            transition={{ duration: 0.8, ease: 'easeInOut' }}
          >
            <Image />
          </motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: showLastImage ? 1 : 0 }}
            transition={{ duration: 0.8, ease: 'easeInOut' }}
          >
            <LastImage />
          </motion.div>  
        </div>
      }

      {type === 'third' &&
        <div className={styles.boxImage} data-type={type}>
          <motion.div
            initial={{ y: '0%' }}
            animate={{ y: '-40%' }}
            transition={{
              ease: 'linear',
              duration: 12,
              repeat: Infinity,
              repeatType: 'loop'
            }}
          >
            {errorImgMap.map(({ id, Component }) => (
              <div className={styles.errorCard} key={id}>
                <Component />
              </div>
            ))}
            {errorImgMap.map(({ id, Component }) => (
              <div className={styles.errorCard} key={`duplicate-${id}`}>
                <Component />
              </div>
            ))}
          </motion.div>
        </div>
      }
    </motion.div>
  );
}
